import {ComparitorData, DataSetList, MetadataRespone, AttributeResponse, ResolutionKeys, ToShowResponse, StateToShow, MessageBuilderData, WaterTye, ComparitorDataMessage} from "../types"



// Get the API URL from environment variable or default to localhost
const API_URL = process.env.REACT_APP_API_URL || '';
// Check if list is exactly [null]

function isNullList(list: any[]): boolean {
  return list.length === 1 && list[0] === null;
}

export async function calculate_expression(resolution : ResolutionKeys, builderData : MessageBuilderData){
    try {
      const response = await fetch(`${API_URL}/api/calculate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          resolution,
          builderData,
        }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const { results } : { results : {[key: string]: string;}} = await response.json();
      return results;
    } catch (error) {
      console.error('Error calculating:', error);
    }
};

export async function handle_get_datasets() {

  // Get datasets
  const response = await fetch(`${API_URL}/api/metadata/dataset_names`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const result: DataSetList = await response.json();
  const datalist = result.Data

  //const { metadata } = await handle_get_metadata_attribute(current_dataset, current_attribute);

  //const attribute = await handle_resolution_or_year_or_month_change(current_dataset, current_attribute, current_parameters, current_resolution, current_year,water_type);

  return { datalist} //({ metadata, datalist, attribute })
}



 export async function get_dataset_list() {
  // Get datasets
  const response = await fetch(`${API_URL}/api/metadata/dataset_names?levels=1,2`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const result: DataSetList = await response.json();
  const datalist = result.Data 

 return ({datalist})
}


export async function handle_session_load(current_dataset: string, current_attribute: string, current_parameters: StateToShow, current_resolution: string, current_year: number | undefined, current_month : number | undefined, water_type : WaterTye) {

  // Get datasets
  const response = await fetch(`${API_URL}/api/metadata/dataset_names?levels=1,2`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const result: DataSetList = await response.json();
  const datalist = result.Data

  const { metadata } = await handle_get_metadata_attribute(current_dataset, current_attribute);

  const is_overlay = metadata.Data.is_overlay === "True" ? "True" : "False";

  let attribute;

  try {
    attribute = await handle_resolution_or_year_or_month_change(current_dataset, current_attribute, current_parameters, current_resolution, current_year, current_month,water_type, is_overlay);
  } catch {
    attribute = undefined;
  }

  return ({ metadata, datalist, attribute })
}

export async function handle_page_load(show_overlays: boolean) {
  let response;
  if (show_overlays)
    response = await fetch(`${API_URL}/api/metadata/dataset_names?levels=1,2&skipOverlays=false`);
  else
    response = await fetch(`${API_URL}/api/metadata/dataset_names?levels=1,2&skipOverlays=true`);

  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const result: DataSetList = await response.json();

  const datalist = result.Data

  const fifth_dataset_name = result.Data.names[5]; // set to second for better looks, might add errors if dataset is empty
  // Fetch metadata and attributes for the selected dataset and resolution
  const {metadata, attribute, current_parameters} = await handle_dataset_change(fifth_dataset_name, 'state', undefined)
  return ({ metadata, attribute, current_parameters, datalist })
}

export async function handle_get_metadata(current_dataset: string) {

  const response = await fetch(`${API_URL}/api/metadata/${current_dataset}`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const metadata: MetadataRespone = await response.json();

  return { metadata };
}

export async function handle_get_level_three_datasets(): Promise<{
  datalist: {
    names: string[];
    titles: string[];
    categories: string[];
  }
}>  {

    // Get datasets
    let response
    try{
      response = await fetch(`${API_URL}/api/metadata/dataset_names?levels=3`);
    } catch {
      return { datalist : {
        names: [],
        titles: [],
        categories: [],
      } }
    }
    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }
    const result: DataSetList = await response.json();
    const datalist = result.Data

    return { datalist } //({ metadata, datalist, attribute })

}

export async function handle_page_load_comparator(){
    const response = await fetch(`${API_URL}/api/metadata/dataset_names?levels=3`);
    if (!response.ok) {
      return {
        metadata: null,
        attribute: null,
        current_parameters: null 
        }
    }
    const result : DataSetList = await response.json();
    const first_dataset_name = result.Data.names[0];

    let metadata_fgw, attribute_fgw, current_parameters_fgw;
    let metadata_bgw, attribute_bgw, current_parameters_bgw;
    let metadata_fsw, attribute_fsw, current_parameters_fsw;

    try { // FGW
      ({metadata: metadata_fgw, attribute: attribute_fgw, current_parameters:current_parameters_fgw} = await handle_dataset_change(first_dataset_name, 'state', 'fgw'));
    } catch (error) {
      //console.error('Error fetching fgw data:', error);
    }
    try { // BGW
      ({metadata: metadata_bgw, attribute: attribute_bgw, current_parameters:current_parameters_bgw} = await handle_dataset_change(first_dataset_name, 'state', 'bgw'));
    } catch (error) {
      //console.error('Error fetching bgw data:', error);
    }
    try { // FSW
      ({metadata: metadata_fsw, attribute: attribute_fsw, current_parameters:current_parameters_fsw} = await handle_dataset_change(first_dataset_name, 'state', 'fsw'));
    } catch (error) {
      //console.error('Error fetching fsw data:', error);
    }

    return ( {
      metadata: {fgw:metadata_fgw, fsw: metadata_fsw, bgw: metadata_bgw},
      attribute: {fgw:attribute_fgw, fsw: attribute_fsw, bgw: attribute_bgw},
      current_parameters: {fgw:current_parameters_fgw, fsw: current_parameters_fsw, bgw: current_parameters_bgw}})
}

export async function handle_get_parameter_list(current_dataset : string){

  const response = await fetch(`${API_URL}/api/metadata/${current_dataset}`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const metadata: MetadataRespone = await response.json();
  const attribute_list = metadata.Data.available_attributes;
  const available_attribute_titles = metadata.Data.available_attribute_titles;
  return { attribute_list, available_attribute_titles }
}

export async function handle_dataset_change(current_dataset : string, current_resolution : ResolutionKeys, current_water_type : WaterTye){

  const response = await fetch(`${API_URL}/api/metadata/${current_dataset}`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const metadata: MetadataRespone = await response.json();

    const current_attribute = metadata.Data.attribute_name
    if(!metadata.Data.available_resolutions.includes(current_resolution)) current_resolution = metadata.Data.available_resolutions[0];

    const current_year = metadata.Data.available_years[0] ? Number(metadata.Data.available_years[0]) : undefined

    const current_month = metadata.Data.available_months[0] ? Number(metadata.Data.available_months[0]) : undefined

    const is_overlay = metadata.Data.is_overlay === "True" ? "True" : "False";

    if( metadata.Data.available_water_types && !isNullList(metadata.Data.available_water_types) && !metadata.Data.available_water_types.includes(current_water_type)){
      throw Error("Now available water type!")
    }

    let attribute;

    //get first parameter
    const current_parameters = set_first_parameters(metadata.Data.to_show);
    try {
      attribute = await handle_resolution_or_year_or_month_change(current_dataset, current_attribute, current_parameters, current_resolution, current_year, current_month, current_water_type, is_overlay);
    } catch {
      attribute = undefined
    }

  return { metadata, attribute, current_parameters }
}

export async function handle_get_metadata_attribute(current_dataset: string, current_attribute: string) {

  const response = await fetch(`${API_URL}/api/metadata/${current_dataset}/${current_attribute}`);
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const metadata: MetadataRespone = await response.json();

  return { metadata }
}

export async function handle_attribute_change(current_dataset: string, current_attribute: string, current_resolution: ResolutionKeys, current_water_type : WaterTye) {

  const { metadata } = await handle_get_metadata_attribute(current_dataset,current_attribute); //: MetadataRespone = await response.json();

  if (!metadata.Data.available_resolutions.includes(current_resolution)) current_resolution = metadata.Data.available_resolutions[0];
  const current_year = Number(metadata.Data.available_years[0])

  const current_month = Number(metadata.Data.available_months[0])

  const current_parameters = set_first_parameters(metadata.Data.to_show);

  const is_overlay = metadata.Data.is_overlay === "True" ? "True" : "False";

  if( metadata.Data.available_water_types && !isNullList(metadata.Data.available_water_types) && !metadata.Data.available_water_types.includes(current_water_type) && !metadata.Data.available_water_types.includes(current_water_type)){
    throw Error("Now available water type!")
  }

  let attribute;

  try {
    attribute = await handle_resolution_or_year_or_month_change(current_dataset, current_attribute, current_parameters, current_resolution, current_year, current_month, current_water_type, is_overlay)
  } catch {
    attribute = undefined
  }

  return {metadata, attribute, current_parameters}
}

export async function handle_resolution_or_year_or_month_change(current_dataset : string, current_attribute : string, current_parameters: StateToShow, current_resolution : string, current_year : number | undefined, current_month : number | undefined, water_type : WaterTye, is_overlay: string){
    let url;
    if( current_year !== undefined && isNaN(current_year)) current_year = undefined;
    if( current_month !== undefined && isNaN(current_month)) current_month = undefined;
    const parameter = get_parameters(current_parameters);
    //const month_text = (current_year ? '/' : '') + (current_month ? current_month.toString().padStart(2, '0') : '')
    const month_text = (current_year ? '/' : '') + (current_month ? current_month : '') // current_month.toString().padStart(2, '0') :

    if (is_overlay === "True" ) current_resolution = "overlay"

    if(water_type === "fgw" || water_type === "fsw" || water_type === 'bgw' ) {
      url = `${API_URL}/api/data/${current_dataset}/${current_attribute}/${parameter ?? "None"}/${current_resolution}/${current_year ?? ""}${month_text}?water_type=${water_type}`;
    } else {
      url = `${API_URL}/api/data/${current_dataset}/${current_attribute}/${parameter ?? "None"}/${current_resolution}/${current_year ?? ""}${month_text}`;
    }
    const response = await fetch(url);

    if (response.status === 404) {
      return undefined;
    }
    
    if (!response.ok) {
        throw new Error("Failed to fetch data"); 
    }


    const result : AttributeResponse = await response.json();

  return result;
}

export async function handle_get_data_of_column(current_dataset : string, current_attribute : string, current_resolution : string, current_year : number | undefined, water_type : WaterTye, is_overlay: string) {
// (current_dataset : string, current_attribute : string, current_parameters: StateToShow, current_resolution : string, current_year : number | undefined, water_type : WaterTye)    
  // kell paraméternek 
  const { metadata } = await handle_get_metadata_attribute(current_dataset,current_attribute);

  current_year = Number(metadata.Data.available_years[0])
  const current_parameters = set_first_parameters(metadata.Data.to_show);

  let url;
  if( current_year !== undefined && isNaN(current_year)) current_year = undefined;
  const parameter = get_parameters(current_parameters);

  if (is_overlay === "True" ) current_resolution = "overlay"
  
  if(water_type === "fgw" || water_type === "fsw" || water_type === 'bgw' ) {
    url = `${API_URL}/api/data/${current_dataset}/${current_attribute}/${parameter ?? "None"}/${current_resolution}/${current_year ?? ""}?water_type=${water_type}`;
  } else {
    url = `${API_URL}/api/data/${current_dataset}/${current_attribute}/${parameter ?? "None"}/${current_resolution}/${current_year ?? ""}`;
  }
  const response = await fetch(url);
  
  if (!response.ok) {
      throw new Error("Failed to fetch data"); 
  }
  const result : AttributeResponse = await response.json();

return { result };
}

export async function handle_compare_histogram( ComparitorDataMessage: ComparitorDataMessage){
  try {
    const response = await fetch(`${API_URL}/api/compare/histogram`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(ComparitorDataMessage),
    });

    if (!response.ok) {
      const error_message = await response.json(); // Parse JSON response
      return {type:'error', data:error_message}
    }

    const data = await response.json(); // Parse JSON response
    return {type:'ok', data:data} ; // Return the received data
  } catch (error) {
    console.error("Failed to fetch histogram data:", error);
    return {type:'severe_error', data:error};
  }
}


export async function handle_compare_check( ComparitorDataMessage: ComparitorDataMessage){
  try {
    const response = await fetch(`${API_URL}/api/compare/check`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(ComparitorDataMessage),
    });

    const data: { "extracted_vars" : string[] } | { "error" : string, "message" : string } = await response.json(); // Parse JSON response
    return data; // Return the received data
  } catch (error) {
    console.error("Failed to fetch calculate data:", error);
    return {  "error": error };
  }
}

export async function handle_compare_calculate( ComparitorDataMessage: ComparitorDataMessage){
  try {
    const response = await fetch(`${API_URL}/api/compare/calculate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(ComparitorDataMessage),
    });

    const data: {"results" : { [key: string]: string }, "extracted_vars" : string[] } | { "error" : string, "message" : string } = await response.json(); // Parse JSON response
    return data; // Return the received data
  } catch (error) {
    console.error("Failed to fetch calculate data:", error);
    return {  "error": error };
  }
}


export function get_parameters(
  to_show_parameters: StateToShow
): string | undefined {
  if (Object.keys(to_show_parameters).length === 0) return undefined;

  return Object.entries(to_show_parameters)
    .sort(([keyA], [keyB]) => {
      const numA = parseInt(keyA.split("_").pop() || "0", 10);
      const numB = parseInt(keyB.split("_").pop() || "0", 10);
      return numA - numB; // Sort in ascending order
    })
    .map(([, param]) => param.current_code)
    .filter(code => code !== undefined)
    .join("_");
}

function set_first_parameters(to_show_parameters: ToShowResponse): StateToShow {
  if (!to_show_parameters || Object.keys(to_show_parameters).length === 0) return {};

  return Object.fromEntries(
    Object.entries(to_show_parameters).map(([key, param]) => {

      return [
        key,
        {
          ...param,
          current_code: param.codes[0] || "",
        },
      ];
    })
  );
}

